<template>
  <div id="my_sidebar">

<!--    <div class="tit">-->
<!--      <div>-->
<!--        <img v-if="avator==''" src="../assets/images/tx.png" class="img-responsive center-block" style="width: 110px;"-->
<!--             alt="">-->
<!--        <div v-if="avator"-->
<!--             style="width:110px;height: 110px;border-radius: 50%;overflow: hidden;margin: 0 auto;position: relative;z-index: 1;">-->
<!--          <img :src="avator" class="img-responsive center-block"-->
<!--               style="width: 100%;height: 100%;position: relative;z-index: 1;object-fit: cover" alt="">-->
<!--        </div>-->
<!--      </div>-->
<!--      <img src="../assets/images/chengeTx.png" alt="" class="change">-->
<!--      <input type="file" name="请选择" @change="uploadFile" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg">-->
<!--      <h4 v-if="nickname!=='undefined'">{{nickname}}</h4>-->
<!--      <h4 v-else> {{username}}</h4>-->
<!--      &lt;!&ndash;        <p>{{address}}</p>&ndash;&gt;-->
<!--    </div>-->
    <div class="side">
      <ul>
        <li :class="{active: isActive==1}" @click="active=1">
          <router-link :to="{path:'personalCenter',query:{asid:1}}">个人中心</router-link>
        </li>
        <li :class="{active: isActive==2}" @click="active=2">
          <router-link :to="{path:'my_product',query:{asid:2}}">我的作品</router-link>
        </li>
        <li :class="{active: isActive==3}" @click="active=3">
          <router-link :to="{path:'my_works',query:{asid:3}}">我的资料</router-link>
        </li>
        <li :class="{active: isActive==4}" @click="active=4">
          <router-link :to="{path:'ChangePassword',query:{asid:4}}">修改密码</router-link>
        </li>
        <li :class="{active: isActive==5}" @click="active=5">
          <router-link :to="{path:'act_code',query:{asid:5}}">产品激活</router-link>
        </li>
        <li :class="{active: isActive==6}">
          <router-link to="/" @click.native="revpwd" style="color: rgba(255, 75, 90, 1)">退出登录</router-link>
        </li>

      </ul>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: "my_sidebar",
    data() {
      return {
        avator: '',
        nickname: '',
        username: '',
        address: localStorage.address
      }
    },
    created() {
      this.isActive = this.$route.query.asid;
      this.avator = localStorage.avator;
      this.nickname = localStorage.nickname;
      this.username = localStorage.username;
    },
    methods: {
      // works() {
      //   this.isActive = 1;
      // },
      // ziliao() {
      //   this.isActive = 2;
      // },
      revpwd() {
        this.isActive = 6;
        this.$router.push('/');
        this.$store.commit('set_userinfo', {});
        this.$store.commit('set_token', '');
        this.$EventBus.$emit('token', '');
      },
      uploadFile(e) {
        let file = e.target.files[0];
        let param = new FormData();
        param.append('image', file);
        let config = {
          headers: {'Content-Type': 'multipart/form-data'}
        };
        // 添加请求头
        axios.post('/api/user_action/uploadAvatar', param, config)
          .then(response => {
            if (response.data.ret === 200) {
              this.avator = response.data.data.avator;
              this.$store.commit('set_userinfo', {
                username: localStorage.username,
                avator: response.data.data.avator,
                address: localStorage.address,
                is_vip: localStorage.is_vip,
                uid: localStorage.uid,
                nickname: localStorage.nickname
              });
              this.$EventBus.$emit('avator',this.avator);
            }
          })
      },
    },
    mounted() {
      this.$EventBus.$on('name', (msg) => {
        this.nickname = msg;
      });
      this.$EventBus.$on('avator', (msg) => {
        this.avator = msg;
      });
    }
  }


</script>

<style scoped>
  input {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    opacity: 0;
    position: absolute;
    top: 20px;
    margin-left: 50%;
    transform: translate(-50%);
    z-index: 999;
  }

  .change {
    border-radius: 50%;
    position: absolute;
    top: 20px;
    transform: translate(-50%);
    z-index: 6;
    color: white;
    font-size: 14px;
  }

  .tit {
    width: 180px;
    height: 200px;
    /*padding-top: 20px;*/
    position: relative;
  }

  .side {
    width: 180px;
    height: 360px;
    /*margin-top: 20px;*/
  }

  h4 {
    margin-top: 20px;
  }

  ul li {
    height: 60px;
    list-style: none;
    line-height: 60px;
  }

  ul {
    padding: 0;
    margin: 0;
    font-size: 16px;
  }

  .active {
    position: relative;
    height: 60px;
  }

  ul .active::after {
    width: 8px;
    height: 60px;
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    background: rgba(43, 156, 165, 1);
  }
</style>



// WEBPACK FOOTER //
// src/components/my_sidebar.vue